/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesContractImportDtosContractImportCommitResponse,
  FacilityFlowCoreModulesContractImportWorkflowsContractAnalyzeResponse,
  PostApiV1ContractImportAnalyzeBody,
  PostApiV1ContractImportCommitBody
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getContractImport = () => {
/**
 * @summary Analyze a scanned contract PDF: vision extraction returns the structured contract
data for user review. Nothing is written.
 */
const postApiV1ContractImportAnalyze = (
    postApiV1ContractImportAnalyzeBody: PostApiV1ContractImportAnalyzeBody,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesContractImportWorkflowsContractAnalyzeResponse>>,) => {const formData = new FormData();
if(postApiV1ContractImportAnalyzeBody.file !== undefined) {
 formData.append(`file`, postApiV1ContractImportAnalyzeBody.file)
 }

      return customInstance<FacilityFlowCoreModulesContractImportWorkflowsContractAnalyzeResponse>(
      {url: `/api/v1/contract-import/analyze`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary Commit the user-reviewed contract data: transactionally creates or links the
customer, contact and object, creates services, task definitions with schedule
rules and checklist items, an offer that is moved to Accepted (setting the
object's active offer and auto-creating the current-month draft invoice), and
stores the PDF as an object document. payload is the
JSON-serialized FacilityFlow.Core.Modules.ContractImport.Dtos.ContractImportCommitRequest.
 */
const postApiV1ContractImportCommit = (
    postApiV1ContractImportCommitBody: PostApiV1ContractImportCommitBody,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesContractImportDtosContractImportCommitResponse>>,) => {const formData = new FormData();
if(postApiV1ContractImportCommitBody.file !== undefined) {
 formData.append(`file`, postApiV1ContractImportCommitBody.file)
 }
if(postApiV1ContractImportCommitBody.payload !== undefined) {
 formData.append(`payload`, postApiV1ContractImportCommitBody.payload)
 }

      return customInstance<FacilityFlowCoreModulesContractImportDtosContractImportCommitResponse>(
      {url: `/api/v1/contract-import/commit`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  return {postApiV1ContractImportAnalyze,postApiV1ContractImportCommit}};
export type PostApiV1ContractImportAnalyzeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getContractImport>['postApiV1ContractImportAnalyze']>>>
export type PostApiV1ContractImportCommitResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getContractImport>['postApiV1ContractImportCommit']>>>
